// Hold the page reload while this component has work the user would lose (issue #3265).
//
// One line in a component that knows it is mid-edit or mid-upload; the hold is lifted when that
// stops being true, when the component unmounts, and when React throws the tree away. See
// user_activity.ts for why only the page reload has holds.

import { useEffect } from 'react';
import { holdAppReload } from './user_activity.ts';

export function useHoldAppReload(active: boolean): void {
  useEffect(() => {
    if (!active) {
      return;
    }
    return holdAppReload();
  }, [active]);
}
